const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path
            d="M25.51 0C39.6 0 51.023 11.408 51.023 25.48c0 14.073-11.422 25.481-25.511 25.481C11.42 50.961 0 39.553 0 25.481 0 11.408 11.422 0 25.51 0zm0 3.475C13.344 3.475 3.48 13.327 3.48 25.48c0 12.153 9.864 22.006 22.032 22.006s22.032-9.853 22.032-22.006c0-12.154-9.864-22.006-22.032-22.006zm0 16.794c.962 0 1.74.777 1.74 1.737v15.636c0 .96-.778 1.737-1.74 1.737-.96 0-1.738-.778-1.738-1.737V22.006c0-.96.778-1.737 1.739-1.737zm0-8.687a2.897 2.897 0 012.9 2.896c0 1.599-1.298 2.895-2.9 2.895a2.897 2.897 0 01-2.898-2.895c0-1.6 1.298-2.896 2.899-2.896z"
            id="info-line_a" />
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h56v56H0z" />
        <g transform="translate(2 3)">
            <mask id="info-line_b" fill="#fff">
                <use xlink:href="#info-line_a" />
            </mask>
            <use fill="currentColor" fill-rule="nonzero" xlink:href="#info-line_a" />
            <path fill="currentColor" mask="url(#info-line_b)" d="M-2.319-2.316h55.66v55.594h-55.66z" />
        </g>
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=info-line.es-BOwPMbJk.js.map
